// GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    body {
    background: ${({ theme }) => theme.background}; /* Fallback color */
    background-image: ${({ theme }) => theme.backgroundImage}; /* Dynamic background image */
    background-size: ${({ theme }) => theme.backgroundSize || 'cover'}; /* Default to cover */
    background-position: ${({ theme }) => theme.backgroundPosition || 'center top'}; /* Starting position */
    background-attachment: ${({ theme }) => theme.backgroundAttachment || 'scroll'}; /* Default to scroll */
    color: ${({ theme }) => theme.color}; /* Text color */
    transition: all 0.50s linear; /* Smooth transitions */
    font-family: 'Times New Roman', Times, serif; /* Add the font-family property */
    margin-top: 20px;
    position: relative;
    overflow-x: hidden;
  }

  body::before,
  body::after {
    content: '';
    position: fixed;
    inset: auto;
    pointer-events: none;
    z-index: 0;
    filter: blur(60px);
    opacity: 0.75;
    animation: floatGlow 16s ease-in-out infinite;
  }

  body::before {
    width: 34vw;
    height: 34vw;
    top: 12vh;
    left: -8vw;
    background: rgba(245, 199, 82, 0.18);
  }

  body::after {
    width: 38vw;
    height: 38vw;
    right: -10vw;
    bottom: 8vh;
    background: rgba(28, 126, 110, 0.16);
    animation-delay: -6s;
  }

  .App {
    position: relative;
    z-index: 1;
  }

  /* Smooth scrolling if needed */
  html {
    scroll-behavior: smooth;
  }

  @keyframes floatGlow {
    0%,
    100% {
      transform: translate3d(0, 0, 0) scale(1);
    }
    50% {
      transform: translate3d(2vw, -2vh, 0) scale(1.08);
    }
  }
`;

export default GlobalStyles;
